// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2756":"0de0d7a9","5134":"7c807c60"}[chunkId] + ".chunk.css";
};